import { render, staticRenderFns } from "./PresupuestoView.vue?vue&type=template&id=2dab0d35&scoped=true&"
import script from "./PresupuestoView.vue?vue&type=script&lang=js&"
export * from "./PresupuestoView.vue?vue&type=script&lang=js&"
import style0 from "./PresupuestoView.vue?vue&type=style&index=0&id=2dab0d35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab0d35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VCard,
  VFlex,
  VLayout,
  VSelect,
  VSubheader,
  VTab,
  VTabItem,
  VTabs,
  VToolbar,
  VToolbarTitle,
})
